import {
    OfficeData,
    OfficeListQuery,
    OfficeUpdateForm,
    OfficeCreateForm,
    OfficeStatus,
    OfficeListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/office';

export class OfficeApi {
    public static async getList(params?: OfficeListQuery): Promise<OfficeData[]> {
        const res = await axios.get<OfficeListResponse>(`${BASE_URL}`, { params });

        return res.data.offices;
    }

    public static async create(office: OfficeCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}`, { office });
    }

    public static async update(id: string, office: OfficeUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { office });
    }

    public static async updateStatus(id: string, status: OfficeStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { office: { status } });
    }
}

export { BASE_URL as OFFICE_API_BASE_URL };
